<template>
	<dialog-slot
		title="Change company"
		@updateClose="onDrawerClose"
		@updateSave="onSave"
	>
		<no-info
				v-if="items && items.length <= 0"
				padding="0"
				text="There is no information regarding customer updates."
		/>
		<main-table
				v-else
				padding="0"
				flag="logs"
				:headers="getHeaders"
				:listItems="items"
				:filtersList="{}"
				:is-hide-header="false"
				:items-per-page-amount="10"
				:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				@updateClickButton="onClickButton"
		></main-table>

		<change-company-drawer
				v-if="isChangeCompanyDrawer"
				:editData="activeItem"
				:customers="customers"
				@closeDrawer="onDrawerCloseChangeCompanyDrawer"
				@updateEditServices="onEditServices"
		></change-company-drawer>

	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";
import { ChangeCompanyTable } from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/defaultHeaders";
import NoInfo from "@/shared/NoInfo/NoInfo.vue";
const ChangeCompanyDrawer = () =>
	import("@/shared/ChangeCompany/ChangeCompanyDrawer/ChangeCompanyDrawer");

export default {
	name: "ChangeCompany",
	components: {
		NoInfo,
		DialogSlot,
		ChangeCompanyDrawer
	},
	computed: {
		getHeaders() {
			return ChangeCompanyTable;
		}
	},
	props: {
		items: Array,
		customers: Array,
	},
	data: () => ({
		activeItem: null,
		isChangeCompanyDrawer: false,
	}),
	methods: {

		onDrawerClose(type) {
			if ( type == "close" || type == "outside" ) this.onClose();
			if ( type == "cancel" ) this.onCancel();
		},
		onClose() {
			this.$emit("updateSettingsClose");
		},
		onCancel() {
			this.$emit("updateSettingsCancel");
		},
		onSave() {
			this.$emit("updateSettingsSave");
			this.onClose();
		},
		onDrawerCloseChangeCompanyDrawer() {
			this.isChangeCompanyDrawer = false;
		},
		onClickButton({ key, item }) {
			this.activeItem = item;
			if (key === "edit1") {
				this.isChangeCompanyDrawer = true;
			}
		},
		onEditServices(values) {
			this.$emit('updateEditServices', values);
		}
	},
};
</script>

